import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
function loadView(view) {
  return (resolve) => require([`../views/${view}.vue`], resolve); //() => import(`../pages/${box}/${view}.vue`);
};
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: loadView('index'),
    },{
      path: '/about',
      name: 'about',
      component: loadView('about'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js